import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: 0, // 0是简体中文，1是英文
    login: false, // 会议报名登录
    login2: false, // 征文报名登录
    login2Data: null,
    signUpId: null,
    userName: null,
    userSignUpId: null,
    phoneOrEmail: null,
    refundSignUpId: null,
    refundSignUpIdStr: null,
    payUrlForH5: null,
    payUrlForWeb: null,
    totalFee: '0',
    login4SignAgain: false,
    backFromCheckin: false,
    data: {}
  },
  mutations: {
    setLanguage (state, lang) {
      state.language = lang
    },
    setLogin (state, login) {
      state.login = login
    },
    setLogin2 (state, login2) {
      state.login2 = login2
    },
    setLogin2Data (state, login2Data) {
      state.login2Data = login2Data
    },
    setSignUpId (state, signUpId) {
      state.signUpId = signUpId
    },
    setUserName (state, userName) {
      state.userName = userName
    },
    setUserSignUpId (state, userSignUpId) {
      state.userSignUpId = userSignUpId
    },
    setPhoneOrEmail (state, phoneOrEmail) {
      state.phoneOrEmail = phoneOrEmail
    },
    setRefundSignUpId (state, refundSignUpId) {
      state.refundSignUpId = refundSignUpId
    },
    setRefundSignUpIdStr (state, refundSignUpIdStr) {
      state.refundSignUpIdStr = refundSignUpIdStr
    },
    setPayUrlForH5 (state, payUrlForH5) {
      state.payUrlForH5 = payUrlForH5
    },
    setPayUrlForWeb (state, payUrlForWeb) {
      state.payUrlForWeb = payUrlForWeb
    },
    setTotalFee (state, totalFee) {
      state.totalFee = totalFee
    },
    setData (state, data) {
      state.data = data
    },
    setLogin4SignAgain (state, login4SignAgain) {
      state.login4SignAgain = login4SignAgain
    },
    setBackFromCheckin (state, backFromCheckin) {
      state.backFromCheckin = backFromCheckin
    }
  },
  getters: {
    getLanguage: state => state.language,
    getLogin: state => state.login,
    getLogin2: state => state.login2,
    getLogin2Data: state => state.login2Data,
    getSignUpId: state => state.signUpId,
    getUserName: state => state.userName,
    getUserSignUpId: state => state.userSignUpId,
    getPhoneOrEmail: state => state.phoneOrEmail,
    getRefundSignUpId: state => state.refundSignUpId,
    getRefundSignUpIdStr: state => state.refundSignUpIdStr,
    getPayUrlForH5: state => state.payUrlForH5,
    getPayUrlForWeb: state => state.payUrlForWeb,
    getTotalFee: state => state.totalFee,
    getData: state => state.data,
    getLogin4SignAgain: state => state.login4SignAgain,
    getBackFromCheckin: state => state.backFromCheckin
  },
  actions: {
  },
  modules: {
  },
  // plugins: [createPersistedState()]
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})
